<template>
  <div class="badge">
    <img
      v-if="complete"
      class="badge-light"
      :src="light"
    >
    <img
      v-if="complete"
      class="badge-icon"
      :src="completeBadge"
    >
    <img
      v-else
      class="badge-icon"
      :src="uncompleteBadge"
    >
  </div>
</template>

<script>
import completeBadge from '@/assets/image/direct/complete.png';
import uncompleteBadge from '@/assets/image/direct/uncomplete.png';
import light from '@/assets/image/direct/light.png';

export default {
  props: {
    // 是否完成
    complete: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      completeBadge,
      uncompleteBadge,
      light,
    };
  },
};
</script>

<style lang="less" scoped>
.badge {
  width: 46px;
  height: 40px;
  position: relative;

  &-light {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    animation: 3s linear infinite rotate;
  }

  &-icon {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 1px;
    left: 3px;
    z-index: 2;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>